var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 117C190.8 117 131.8 128.6 89.87 146.7C68.92 155.8 52.3 166.5 41.3 177.8C30.3 189.1 25 200.4 25 212C25 223.6 30.3 234.9 41.3 246.2C52.3 257.5 68.92 268.2 89.87 277.3C131.8 295.4 190.8 307 256 307C321.2 307 380.2 295.4 422.1 277.3C443.1 268.2 459.7 257.5 470.7 246.2C481.7 234.9 487 223.6 487 212C487 200.4 481.7 189.1 470.7 177.8C459.7 166.5 443.1 155.8 422.1 146.7C380.2 128.6 321.2 117 256 117ZM25 255.1V305.3C25 311.6 30.3 322.9 41.3 334.2C52.3 345.5 68.92 356.2 89.87 365.3C131.8 383.4 190.8 395 256 395C321.2 395 380.2 383.4 422.1 365.3C443.1 356.2 459.7 345.5 470.7 334.2C481.7 322.9 487 311.6 487 305.3V255.1C485.9 256.4 484.8 257.6 483.6 258.8C470.3 272.4 451.8 284.1 429.3 293.8C384.3 313.3 323.3 325 256 325C188.7 325 127.7 313.3 82.72 293.8C60.23 284.1 41.71 272.4 28.42 258.8C27.23 257.6 26.1 256.3 25 255.1Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/tokens.0055e5238c900a2c21e8db080d41c243.svg";
export { ForwardRef as ReactComponent };